import { render, staticRenderFns } from "./DDSDashboardCards.vue?vue&type=template&id=3f55c3ec&scoped=true"
import script from "./DDSDashboardCards.vue?vue&type=script&lang=js"
export * from "./DDSDashboardCards.vue?vue&type=script&lang=js"
import style0 from "./DDSDashboardCards.vue?vue&type=style&index=0&id=3f55c3ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f55c3ec",
  null
  
)

export default component.exports